import React from 'react';
import { useNavigate } from 'react-router-dom';
import LwtErrorBoundary from '@lwtears/lwt-common-frontend/lib/LwtErrorBoundary';
import useApplicationError from '../../hooks/use-application-error';
import { useErrorActions } from '../../providers/ErrorProvider';

const MaybeLwtErrorBoundary: React.FC = ({ children }) => {
  const navigate = useNavigate();
  const { sendApplicationErrorLog } = useApplicationError();
  const { setError } = useErrorActions();

  const handleRedirect = () => {
    navigate('/oops');
  };

  const handleError = (data) => {
    setError(500, data.message || 'An unexpected error occurred in the application');
    sendApplicationErrorLog(data);
  };

  return (
    <LwtErrorBoundary errorHandler={handleError} redirectHandler={handleRedirect}>
      {children}
    </LwtErrorBoundary>
  );
};

export default MaybeLwtErrorBoundary;
